import { SiteConfig } from "../../types";
import { swPrompt } from "../clubedealemao.com/sw-prompt";

export const _config: SiteConfig = {
  isDefault: false,
  enableStripeBilling: false,
  showTidio: false,
  serviceName: "Sprache&Wissen",
  publicUrl: "https://swai.spracheundwissen.com",
  appLogoPath: "/partner/spracheundwissen/logo.png",
  appLogoHeight: "40px",
  landingLogoPath: "/partner/spracheundwissen/logo-inv.png",
  landingLogoHeight: "40px",
  overrideLanding: true,
  uiLanguage: "pt-BR",
  reviewLink: "https://depoimentos.spracheundwissen.com",
  showLanguageGuides: true,
  adminEmail: "contato@clubedealemao.com",
  adminPhoneNumber: "+55 35 9890-8169",
  whatsAppNumber: 553598908169,
  emailsSender: "info@lang-services.com",
  tocLink: "https://escola.spracheundwissen.com/termos/",
  privacyLink: "https://escola.spracheundwissen.com/termos/",
  copyright: "Sprache&Wissen",
  bioPrompt: `
    You are a tutor at SWAI, part of Sprache&Wissen, a Brazilian online German school that offers comprehensive language courses and specialized programs.
    ${swPrompt}
  `,
  // hideProgressMenuLink: true,
  // hideAsideMenuConversations: false,
  avatarExcludeList: [
    "Microsoft Server Speech Text to Speech Voice (en-US, RyanMultilingualNeural)",
    "Microsoft Server Speech Text to Speech Voice (en-US, JennyMultilingualV2Neural)",
    "Microsoft Server Speech Text to Speech Voice (zh-CN, XiaoyouNeural)",
    "Microsoft Server Speech Text to Speech Voice (en-US, AnaNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, AmalaNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, BerndNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, GiselaNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, KasperNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, KlausNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, LouisaNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, MajaNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, RalfNeural)",
    "Microsoft Server Speech Text to Speech Voice (de-DE, TanjaNeural)",
  ],
  siteColors: {
    special: {
      // desktopSidebar: "#fff",
      // desktopSidebarBorderColor: "#e2e8f0",
      // desktopSidebarText: "#000",
      // desktopSidebarTextHover: "#eee",
      // chatAsideMenu: "#37393b",
      // speakInputIdle: "var(--chakra-colors-brand-secondary-700)",
      // speakInputRecording: "var(--chakra-colors-brand-secondary-800)",
      // speakInputRecordingCancel: "var(--chakra-colors-brand-secondary-900)",
    },
  },
  colors: {
    primary: {
      main: "#ebbd17",
      mainContrast: "#000",
      "50": "#fdf7e4",
      "100": "#f5e090",
      "200": "#ecc125",
      "300": "#c9a114",
      "400": "#b39012",
      "500": "#ebbd17",
      "600": "#80670c",
      "700": "#66520a",
      "800": "#564608",
      "900": "#3e3206",
    },
    secondary: {
      main: "#cd5658",
      "50": "#fcf6f6",
      "100": "#f4dadb",
      "200": "#ebbabb",
      "300": "#df9192",
      "400": "#d8797b",
      "500": "#cd5658",
      "600": "#c33335",
      "700": "#ab0d10",
      "800": "#920b0d",
      "900": "#6b080a",
    },
    tertiary: {
      main: "#ff5659",
      "50": "#fff5f5",
      "100": "#ffd7d7",
      "200": "#ffb1b3",
      "300": "#ff7f81",
      "400": "#ff5c5e",
      "500": "#db4a4c",
      "600": "#b93e41",
      "700": "#953234",
      "800": "#7e2b2c",
      "900": "#5c1f20",
    },
    light: {
      main: "#f8dfaa",
      alt: "#ececec",
    },
    // https://palette.saas-ui.dev/
    gray: {
      "50": "#fafafa",
      "100": "#f1f1f1",
      "200": "#e7e7e7",
      "300": "#d4d4d4",
      "400": "#adadad",
      "500": "#7f7f7f",
      "600": "#545454",
      "700": "#373737",
      "800": "#202020",
      "900": "#191919",
    },
    yellow: {
      "50": "#fffefa",
      "100": "#fcfade",
      "200": "#f6f09a",
      "300": "#efe341",
      "400": "#dccf16",
      "500": "#b6ab12",
      "600": "#91890e",
      "700": "#716a0b",
      "800": "#555008",
      "900": "#464207",
    },
    green: {
      "50": "#f2fef9",
      "100": "#b6f9de",
      "200": "#4df0ae",
      "300": "#15d98a",
      "400": "#13be79",
      "500": "#10a368",
      "600": "#0d8756",
      "700": "#0a6943",
      "800": "#085637",
      "900": "#07472d",
    },
    teal: {
      "50": "#effcfe",
      "100": "#b8f2f9",
      "200": "#70e6f3",
      "300": "#16d1e5",
      "400": "#13b1c3",
      "500": "#1097a6",
      "600": "#0d7b87",
      "700": "#0a5f69",
      "800": "#095057",
      "900": "#074148",
    },
    cyan: {
      "50": "#f3fbfe",
      "100": "#ceeffb",
      "200": "#b7e7f9",
      "300": "#9cdef6",
      "400": "#46c2ef",
      "500": "#17b2eb",
      "600": "#15a0d4",
      "700": "#1185af",
      "800": "#0e6d90",
      "900": "#0b5570",
    },
    blue: {
      "50": "#f1f6fe",
      "100": "#cddffb",
      "200": "#a8c8f7",
      "300": "#7eadf4",
      "400": "#5694f0",
      "500": "#307ced",
      "600": "#1564da",
      "700": "#104da7",
      "800": "#0d3f89",
      "900": "#0b3370",
    },
    purple: {
      "50": "#f9f5fe",
      "100": "#e8d9fc",
      "200": "#d7bcf9",
      "300": "#bd91f6",
      "400": "#aa73f3",
      "500": "#9047ef",
      "600": "#7a22ec",
      "700": "#6314cb",
      "800": "#5210a8",
      "900": "#3e0c7e",
    },
    pink: {
      "50": "#fef5f9",
      "100": "#fcd7e6",
      "200": "#f9b7d1",
      "300": "#f588b3",
      "400": "#f1629b",
      "500": "#eb1a6e",
      "600": "#cb145d",
      "700": "#a7104d",
      "800": "#830d3c",
      "900": "#610a2d",
    },
    red: {
      "50": "#fef5f4",
      "100": "#fbd8d4",
      "200": "#f8b5ae",
      "300": "#f4877b",
      "400": "#f16a5b",
      "500": "#ec3521",
      "600": "#cb2614",
      "700": "#a41f10",
      "800": "#8c1a0e",
      "900": "#66130a",
    },
    orange: {
      "50": "#fefaf4",
      "100": "#fbebd3",
      "200": "#f7d39f",
      "300": "#f0b050",
      "400": "#e29016",
      "500": "#c27c13",
      "600": "#a46910",
      "700": "#83530d",
      "800": "#67420a",
      "900": "#553608",
    },
  },
};
